import * as React from 'react'
import { IProviderProps } from '@user/components/Filters'
import {
  leadTypeImportOption,
  LeadTypeOptions,
  leadTypeServiceBotOption,
} from './typings'
import { useServiceBotEnabled } from '@user/store/tenantFeatures/hooks/useServiceBotEnabled'

export const LeadTypeProvider: React.FC<IProviderProps> = ({ render }) => {
  const enabledServiceBot = useServiceBotEnabled()

  let LeadTypeData = LeadTypeOptions ?? []

  if (enabledServiceBot) {
    LeadTypeData = [...LeadTypeData, ...leadTypeServiceBotOption]
  }

  LeadTypeData = [...LeadTypeData, ...leadTypeImportOption]

  return <>{render(LeadTypeData, false)}</>
}
LeadTypeProvider.displayName = 'LeadTypeProvider'
